/**
 * Created by Jerker Nord on 2023-10-20.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../../core/winpresentation/SimplePresentationRunner";
import {Loner} from "../../../Loner";
import {LonerGameMode} from "../../../server/LonerGameMode";
import {gsap} from "gsap";

export class LonerTickTickBoomIntroPresentation implements SimplePresentation {

    public shouldRun(): boolean {
        return (Loner.model.data.mode == LonerGameMode.NORMAL && Loner.model.data.nextMode == LonerGameMode.FEATURE_TICK_TICK_BOOM);
    }

    public start(controller:SimplePresentationRunnerController):void {
        Loner.tickTickBoomIntroView.getShowTL(() => LonerTickTickBoomIntroPresentation.fsIntroClosedCallback(controller));
    }

    private static fsIntroClosedCallback(controller:SimplePresentationRunnerController):void {
        controller.finish();
    }
}